<div id="mainContainer">

    <app-toolbar></app-toolbar>

    <router-outlet></router-outlet>

</div>